export default __webpack_public_path__ + "static/media/logo-design1.fb442aff.png";